import Vue from "vue";
import Vuex from "vuex";
import Reservation from "@/components/shared/GuestForm/Model/Reservation";
import createLogger from "vuex/dist/logger";
import { Helper } from "zoox-infra";
import { SubscriptionService } from "zoox-messenger-helper";

const debug = process.env.NODE_ENV !== "production";
const zdblEnable = Helper.getParameterByName("zdbl");

Vue.use(Vuex);

const cleanState = {
  loading: 0,
  longLoading: 0,
  mediaSupported: true,
  currentGuest: {},
  currentReservation: new Reservation(),
  isRec: 0,
  guestDocumentData: {},
  reservations: [],
  lastDocumentSearch: {},
  currentPersonId: "",
  currentPhoto: "",
  debugConfig: {
    ENV: process.env.NODE_ENV,
    isDebug: debug && zdblEnable
  },
  showSplashScreen: true,
  currentMobileStep: 1,
  payStep: 0,
  useTerms: 0,
  privacyTerms: 0,
  mediaTerms: 0,
  qualificationDataTerms: 0,
  emailTerms: 0,
  authenticatedPersonGuestId: null,
  isQualifiedGuest: false,
  cameFromRecon: false,
  isSamePersonFromRecon: false,
  isBackingStep: false,
  pushNotificationService: new SubscriptionService(),
  isEditingOtherGuest: false
};

const Store = new Vuex.Store({
  state: Object.assign({}, cleanState),
  mutations: {
    RESET_STATE: function(state) {
      state.currentReservation = cleanState.currentReservation;
      state.isRec = cleanState.isRec;
      state.guestDocumentData = cleanState.guestDocumentData;
      state.reservations = cleanState.reservations;
      state.lastDocumentSearch = cleanState.lastDocumentSearch;
      state.currentPersonId = cleanState.currentPersonId;
      state.currentPhoto = cleanState.currentPhoto;
      state.curentMobileStep = cleanState.currentMobileStep;
      state.payStep = cleanState.payStep;
      state.useTerms = cleanState.useTerms;
      state.privacyTerms = cleanState.privacyTerms;
      state.mediaTerms = cleanState.mediaTerms;
      state.qualificationDataTerms = cleanState.qualificationDataTerms;
      state.emailTerms = cleanState.emailTerms;
      state.authenticatedPersonEmail = cleanState.authenticatedPersonEmail;
      state.isQualifiedGuest = cleanState.isQualifiedGuest;
      state.isSamePersonFromRecon = cleanState.isSamePersonFromRecon;
      state.isEditingOtherGuest = cleanState.isEditingOtherGuest;
    },
    SET_EDITING_OTHER_GUEST: function(state, payload) {
      state.isEditingOtherGuest = payload;
    },
    SET_CURRENT_GUEST: function(state, payload) {
      state.currentGuest = payload;
    },
    SET_IS_QUALIFIED_GUEST: function(state, payload) {
      state.isQualifiedGuest = payload;
    },
    SET_CAME_FROM_RECON: function(state, payload) {
      state.cameFromRecon = payload;
    },
    SET_IS_BACKING_STEP: function(state, payload) {
      state.isBackingStep = payload;
    },
    SET_IS_SAME_PERSON_FROM_RECON: function(state, payload) {
      state.isSamePersonFromRecon = payload;
    },
    SET_CURRENT_RESERVATION: function(state, payload) {
      state.currentReservation = payload;
    },
    SET_IS_REC: function(state, payload) {
      state.isRec = payload;
    },
    SET_GUEST_DOCUMENT_DATA: function(state, { guestId, documentData }) {
      state.guestDocumentData[guestId] = documentData;
    },
    SET_AUTHENTICATED_PERSON_EMAIL: function(state, payload) {
      state.authenticatedPersonEmail = payload;
    },
    SET_RESERVATIONS: function(state, payload) {
      state.reservations = payload;
    },
    SET_DOCUMENT_SEARCH: function(state, payload) {
      state.lastDocumentSearch = payload;
    },
    SET_CURRENT_PERSON_ID: function(state, payload) {
      state.currentPersonId = payload;
    },
    SET_CURRENT_PHOTO: function(state, payload) {
      state.currentPhoto = payload;
    },
    SET_MEDIA_NO_SUPPORT: function(state) {
      state.mediaSupported = false;
    },
    SET_CURRENT_MOBILE_STEP: function(state, payload) {
      state.currentMobileStep = payload;
    },
    SET_PAY_STEP: function(state, payload) {
      state.payStep = payload;
    },
    SET_USE_TERMS: function(state, payload) {
      state.useTerms = payload;
    },
    SET_MEDIA_TERMS: function(state, payload) {
      state.mediaTerms = payload;
    },
    SET_PRIVACY_TERMS: function(state, payload) {
      state.privacyTerms = payload;
    },
    SET_QUALIFICATION_DATA_TERMS: function(state, payload) {
      state.qualificationDataTerms = payload;
    },
    SET_EMAIL_TERMS: function(state, payload) {
      state.emailTerms = payload;
    },
    CLOSE_SPLASH_SCREEN: function(state) {
      state.showSplashScreen = false;
    },
    "loader/START_LOADING": function(state, payload) {
      if (payload.showLoading) {
        state.loading = state.loading + 1;
      }
    },
    "loader/FINISH_LOADING": function(state, payload) {
      if (payload.showLoading) {
        state.loading = state.loading - 1;
      }
    },
    "loader/START_LONG_LOADING": function(state) {
      state.longLoading = state.longLoading + 1;
    },
    "loader/FINISH_LONG_LOADING": function(state) {
      state.longLoading = state.longLoading - 1;
    }
  },
  actions: {
    $setIsEditingOtherGuest: function(state, value) {
      state.commit("SET_EDITING_OTHER_GUEST", value);
    },
    $resetState: function(state) {
      state.commit("RESET_STATE");
    },
    $setAuthenticatedPersonEmail: function(state, value) {
      state.commit("SET_AUTHENTICATED_PERSON_EMAIL", value);
    },
    $setIsQualifiedGuest: function(state, value) {
      state.commit("SET_IS_QUALIFIED_GUEST", value);
    },
    $setCameFromRecon: function(state, value) {
      state.commit("SET_CAME_FROM_RECON", value);
    },
    $setIsBackingStep: function(state, value) {
      state.commit("SET_IS_BACKING_STEP", value);
    },
    $setIsSamePersonFromRecon: function(state, value) {
      state.commit("SET_IS_SAME_PERSON_FROM_RECON", value);
    },
    $setCurrentGuest: function(state, value) {
      state.commit("SET_CURRENT_GUEST", value);
    },
    $setCurrentReservation: function(state, value) {
      state.commit("SET_CURRENT_RESERVATION", value);
      localStorage.setItem("currentReservation", JSON.stringify(value));
    },
    $setIsRec: function(state, value) {
      state.commit("SET_IS_REC", value);
    },
    $setGuestDocumentData: function(state, value) {
      state.commit("SET_GUEST_DOCUMENT_DATA", value);
    },
    $setReservations: function(state, value) {
      state.commit("SET_RESERVATIONS", value);
    },
    $setDocumentSearch: function(state, value) {
      state.commit("SET_DOCUMENT_SEARCH", value);
    },
    $setCurrentPersonId: function(state, value) {
      state.commit("SET_CURRENT_PERSON_ID", value);
    },
    $setCurrentPhoto: function(state, value) {
      state.commit("SET_CURRENT_PHOTO", value);
    },
    $setMediaNoSupport: function(state) {
      state.commit("SET_MEDIA_NO_SUPPORT");
    },
    $setCurrentMobileStep: function(state, value) {
      state.commit("SET_CURRENT_MOBILE_STEP", value);
    },
    $setPayStep: function(state, value) {
      state.commit("SET_PAY_STEP", value);
    },
    startLongLoading: function(store) {
      store.commit("loader/START_LONG_LOADING");
    },
    stopLongLoading: function(store) {
      store.commit("loader/FINISH_LONG_LOADING");
    },
    $setUseTerms: function(state, value) {
      state.commit("SET_USE_TERMS", value);
    },
    $setMediaTerms: function(state, value) {
      state.commit("SET_MEDIA_TERMS", value);
    },
    $setPrivacyTerms: function(state, value) {
      state.commit("SET_PRIVACY_TERMS", value);
    },
    $setQualificationDataTerms: function(state, value) {
      state.commit("SET_QUALIFICATION_DATA_TERMS", value);
    },
    $setEmailTerms: function(state, value) {
      state.commit("SET_EMAIL_TERMS", value);
    },
    $closeSplashScreen: function(state) {
      state.commit("CLOSE_SPLASH_SCREEN");
    }
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
});

window.__zooxStore = Store;

export default Store;
